/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductSingle extends HTMLElement {
    #variant;
    connectedCallback() {
        this.mediaGallery = this.querySelector("media-gallery");
        this.#moveModalsFromStickyScrollContainer();
    }
    set variant(variant) {
        this.#variant = variant;
    }
    get variant() {
        return this.#variant;
    }
    #moveModalsFromStickyScrollContainer() {
        const modals = this.querySelectorAll("sticky-scroll modal-dialog, sticky-scroll popup-dialog");
        modals.forEach((modal => {
            this.append(modal);
        }));
    }
}

customElements.define("product-single", ProductSingle);

let isAccordionPositionedForMobile = false;


/**
 * Sets the position of the accordion above the perfect pairings on mobile.
 * If the product single is wider than 996px, the accordion is moved to the bottom of the secondary blocks.
 * If the product single is narrower than 996px, the accordion is moved above the perfect pairings.
 */
function setAccordionPosition() {
  const productSingle = document.querySelector('.js-product-single');

  if (!!(productSingle)) {
    const accordion = document.querySelector('.js-product-single__box__block--tab');
    
    if (productSingle.offsetWidth <= MOBILE_BREAKPOINT && !isAccordionPositionedForMobile) {
      const buyButtons = document.querySelector('.product-single__box__block--buy_buttons');
      const highlights = document.querySelector('.product-single__box__block--buy_buttons + .product-single__box__block');
      const perfectPairings = document.querySelector('.product-single__box__block--buy_buttons ~ .js-product-single__box__block--complementary-products');

      if (!!(accordion)) {
        if (!!(highlights) && !highlights.classList.contains('js-product-single__box__block--complementary-products')) {
          highlights.insertAdjacentElement('afterend', accordion);
        } else if (!!(perfectPairings)) {
          perfectPairings.parentElement.insertBefore(accordion, perfectPairings);
        } else if (!!(buyButtons)) {
          buyButtons.insertAdjacentElement('afterend', accordion);
        }

        isAccordionPositionedForMobile = true;
      }
    } else if (productSingle.offsetWidth >= DESKTOP_BREAKPOINT && isAccordionPositionedForMobile) {
      const secondaryBlocks = document.querySelector('.js-product-single__secondary-blocks');

      if (!!(accordion) && !!(secondaryBlocks)) {
        secondaryBlocks.appendChild(accordion, secondaryBlocks);

        isAccordionPositionedForMobile = false;
      }
    }
  }
}

/**
 * Sticky buy bar
 */
document.addEventListener('DOMContentLoaded', function() {
  const buyBar = document.querySelector('.js-product-form__buy-bar');
  const productAddButton = document.querySelector('.product-form__add > .js-product-add');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!!(buyBar)) {
          if (!entry.isIntersecting && window.scrollY > (document.querySelector('.js-product-buttons').getBoundingClientRect().top + window.scrollY)) {
            buyBar.hidden = false;
            document.body.style.paddingBottom = buyBar.getBoundingClientRect().height + 'px';
          } else {
            buyBar.hidden = true;
          }
        }
      });
    },
    { threshold: 1.0 }
  );

  if (!!(buyBar) && !!(productAddButton)) {
    observer.observe(productAddButton);
  }

  // Shop Pay Installments

  const shopPayInstallmentsObserver = new MutationObserver(() => {
    const shopPayInstallmentsCta = document.querySelector('shopify-payment-terms')?.shadowRoot?.getElementById('shopify-installments-cta');

    if (!!(shopPayInstallmentsCta)) {
      shopPayInstallmentsCta.innerText = 'Learn More';
      shopPayInstallmentsObserver.disconnect();
    }
  });

  shopPayInstallmentsObserver.observe(document.body, { childList: true, subtree: true });

  const accordionObserver = new ResizeObserver(debounce(setAccordionPosition, DEBOUNCE_DELAY));
  accordionObserver.observe(document.querySelector('.js-product-single'));
});

//# sourceMappingURL=product-single.js.map
